import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class Products extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json');
        this.setHeader('Accept', 'application/json');
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`);

    }

    static request(Callback) {
        return new Products(Callback);
    }


    productList() {
        return this.get('product/list');
    }

    updateProduct(data, id) {
        return this.put(`product/${id}`, data);
    }

    products() {
        return this.get('product');
    }

    creatProduct(data) {
        return this.post('product', data);
    }

    editProducts(data) {
        return this.put('product/BulkEdit', data);
    }

    updateCreateProduct(data, method, id) {
        return this[method](`product/${id || ''}`, data)

    }
}

export default Products;
